var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 53,
    viewBox: "0 0 68 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.52 12.15V14.94H9.67V21.09H16.57V23.88H9.67V33H6.25V12.15H18.52ZM34.2595 28.74H25.5295L24.0295 33H20.4595L27.9295 12.12H31.8895L39.3595 33H35.7595L34.2595 28.74ZM33.2995 25.95L29.9095 16.26L26.4895 25.95H33.2995ZM58.7474 36.78L55.0874 32.82C54.1874 33.08 53.1974 33.21 52.1174 33.21C50.1774 33.21 48.3874 32.76 46.7474 31.86C45.1274 30.94 43.8374 29.67 42.8774 28.05C41.9374 26.41 41.4674 24.57 41.4674 22.53C41.4674 20.49 41.9374 18.66 42.8774 17.04C43.8374 15.42 45.1274 14.16 46.7474 13.26C48.3874 12.34 50.1774 11.88 52.1174 11.88C54.0774 11.88 55.8674 12.34 57.4874 13.26C59.1274 14.16 60.4174 15.42 61.3574 17.04C62.2974 18.66 62.7674 20.49 62.7674 22.53C62.7674 24.45 62.3474 26.19 61.5074 27.75C60.6874 29.29 59.5474 30.53 58.0874 31.47L63.0974 36.78H58.7474ZM44.9774 22.53C44.9774 24.07 45.2774 25.43 45.8774 26.61C46.4974 27.77 47.3474 28.67 48.4274 29.31C49.5074 29.93 50.7374 30.24 52.1174 30.24C53.4974 30.24 54.7274 29.93 55.8074 29.31C56.8874 28.67 57.7274 27.77 58.3274 26.61C58.9474 25.43 59.2574 24.07 59.2574 22.53C59.2574 20.99 58.9474 19.64 58.3274 18.48C57.7274 17.32 56.8874 16.43 55.8074 15.81C54.7274 15.19 53.4974 14.88 52.1174 14.88C50.7374 14.88 49.5074 15.19 48.4274 15.81C47.3474 16.43 46.4974 17.32 45.8774 18.48C45.2774 19.64 44.9774 20.99 44.9774 22.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 42.5,
    x2: 64,
    y2: 42.5,
    stroke: "#DE0E3D",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5_33",
    x: 0,
    y: 0,
    width: 72,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_33"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5_33",
    result: "effect2_dropShadow_5_33"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5_33",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.4e0ceedbfd73cbd504cdd5931fa3344e.svg";
export { ForwardRef as ReactComponent };